export function CameraOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.63339 18.3333H14.3667C16.6667 18.3333 17.5834 16.925 17.6917 15.2083L18.1251 8.32496C18.2417 6.52496 16.8084 4.99996 15.0001 4.99996C14.4917 4.99996 14.0251 4.70829 13.7917 4.25829L13.1917 3.04996C12.8084 2.29163 11.8084 1.66663 10.9584 1.66663H9.05006C8.19173 1.66663 7.19173 2.29163 6.80839 3.04996L6.20839 4.25829C5.97506 4.70829 5.50839 4.99996 5.00006 4.99996C3.19172 4.99996 1.75839 6.52496 1.87506 8.32496L2.30839 15.2083C2.40839 16.925 3.33339 18.3333 5.63339 18.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 6.66663H11.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99996 15C11.4916 15 12.7083 13.7834 12.7083 12.2917C12.7083 10.8 11.4916 9.58337 9.99996 9.58337C8.50829 9.58337 7.29163 10.8 7.29163 12.2917C7.29163 13.7834 8.50829 15 9.99996 15Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
